<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
      <v-col cols="12" sm="4" class="Full-Course-Library-Title">  External Training </v-col>
      <v-col  cols="12" sm="8" style="padding:0">
          <div :class="['d-flex', 'flex-wrap',{
          'float-left mt-2 pl-3': $vuetify.breakpoint.smAndDown,
          'float-right': $vuetify.breakpoint.mdAndUp,
          }]">
          <v-btn
            color="primary"
            outlined
            @click.prevent="showCreatePanel"
            class="add-course-button"
          >
            Add External training
          </v-btn>
        </div>
        </v-col>
       </v-row>
       <v-row style="margin-top: 20px">
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
      <v-data-table
        :headers="headers"
        :options.sync="options"
        :server-items-length="serverItemsLength"
        v-show="!loading"
        :items="external"
        class="training-table"
      >
      <template v-slot:item.name="{ item }">
           <span :title="item.name"> {{ item.name.length > 30 ? item.name.slice(0, 30) + '...' : item.name }} </span>
      </template>
      <template v-slot:item.body="{ item }">
           <span :title="item.body"> {{ item.body ? (item.body.length > 30 ? item.body.slice(0, 30) + '...' : item.body) : '' }} </span>
      </template>
        <template v-slot:item.id="{ item }">
          <v-select
                  v-if="screenSize === 'tablet' || screenSize === 'mobile'"
                  v-model="selectedAction"
                  :items="getActionList(item)"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Action"
                  @change="performAction(item)"
                ></v-select>
                <template v-else>
          <v-tooltip v-if="item.file" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :href="item.file.data.url"
                v-on="on"
                color="secondary"
                target="_blank"
                text
                small
              >
                <v-icon small>fa-file-alt</v-icon>
              </v-btn>
            </template>
            <span>View Certificate</span>
          </v-tooltip>
          <v-tooltip v-if="item.file" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="error"
                text
                small
                @click.prevent="deleteCertificate(item.id)"
              >
                <v-icon small>fa-times</v-icon>
              </v-btn>
            </template>
            <span>Delete Certificate</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="secondary"
                v-on="on"
                @click.prevent="showEditPanel(item.id)"
                text
                small
              >
                <v-icon small>fa-pencil-alt</v-icon>
              </v-btn>
            </template>
            <span>Edit training record</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="$improve-grey-900"
                v-on="on"
                target="_blank"
                @click="deleteExternalTraining(item.id)"
                text
                small
              >
                <v-icon small>fa fa-trash</v-icon>
              </v-btn>
            </template>
            <span>Delete training record</span>
          </v-tooltip>
          </template>
        </template>
      </v-data-table>
    </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import externalAPI from '@/api/external.js';
import LayoutBasic from '@/layouts/Dashboard';
import CreateExternalTraining from '@/components/authenticated/profile/externaltraining/Create';
import EditExternalTraining from '@/components/authenticated/profile/externaltraining/Edit';

import { screensize } from '../../../utils/screensize';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'ExternalTraining',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Course Title', value: 'name' },
        { text: 'Date Completed', value: 'completed_formatted' },
        { text: 'Training Type', value: 'type_in_text' },
        { text: 'Institute / Body', value: 'body' },
        { text: 'Score (%)', value: 'score' },
        { text: 'Result', value: 'result' },
        { text: 'Cost (£)', value: 'cost' },
        { text: 'Expiry Date', value: 'deadline_formatted' },
        { text: '', value: 'id', align: 'end' },
      ],
      external: [],
      loading: false,
      pagination: {},
      options: {},
      areYouSure: 'Are you sure you want to delete this course?',
      confirmCertificateDelete:
        'Are you sure you wish to delete this certificate?',
      selectedAction: null,        
      screenSize: currentScreenSize,
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getExternalTraining();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
     handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    getActionList(item) {
      let actions = [
        { name: 'View Certificate', action: () => this.openCertificate(item.file.data.url) },
        { name: 'Delete Certificate', action: () => this.deleteCertificate(item.id) },
        { name: 'Edit Training Record', action: () => this.showEditPanel(item.id) },
        { name: 'Delete Training Record', action: () => this.deleteExternalTraining(item.id)},
      ];
      return actions;
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },
     openCertificate(url){
        if (url != null) {
        window.open(url, '_blank');
      }
    },
    setEventBus() {
      EventBus.$on('EXTERNAL_TRAINING_UPDATED', (payload) => {
        this.options = payload;
        this.getExternalTraining();
      });
       EventBus.$on('TRAINING_CATEGORY_UPDATED', () => {
        this.getExternalTraining();
      });
    },
    getExternalTraining() {
      this.loading = true;
      externalAPI.getAllExternalTraining(this.params).then((resp) => {
        this.external = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    deleteExternalTraining(id) {
      this.$snotify.confirm(this.areYouSure, {
        backdrop:0.3,                         
        buttons: [
          { text: 'No', className: 'toast-cancel-button', action: (toast) => this.cancelDelete(toast) },
          { text: 'Yes',className: 'toast-continue-button', action: (toast) => this.confirmDelete(toast, id) }          
        ],
      });
    },
    confirmDelete(toast, id) {
      externalAPI.removeExternalTraining(id).then((resp) => {
        this.getExternalTraining();
      });
      this.$snotify.remove(toast.id);
    },
    cancelDelete(toast) {
      this.$snotify.remove(toast.id);
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateExternalTraining,
        props: {
          options: this.options,
        },
        openOn: 'right',
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditExternalTraining,
        props: {
          options: this.options,
          id: id,
        },
        openOn: 'right',
      });
    },
    deleteCertificate(id) {
      this.$snotify.confirm(this.confirmCertificateDelete, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteCertificate(toast, id),
          }         
        ],
      });
    },
    processDeleteCertificate(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      externalAPI.removeExternalTrainingCertificate(id).then(() => {
        this.getExternalTraining();
        this.loading = false;
      });
    },
  },
};
</script>
